import "./Modals.scss";
import { ModalFullWindow, Typography, Button } from "@bracket/ui";

import LoseGif from "./assets/lose.gif";

type LoseModalProps = {
  closeModal: () => void;
};

export const LoseModal = ({ closeModal }: LoseModalProps) => {
  return (
    <ModalFullWindow>
      <img src={LoseGif} width={"600px"} />
      <Typography variant="h2">You lose</Typography>
      <Typography variant="textXXL" as="p" color="#F6DD7E">
        + 0 [BARS]
      </Typography>
      <Button
        onClick={closeModal}
        label="Play again"
        width="300px"
        ml="auto"
        mr="auto"
        mt="auto"
      />
    </ModalFullWindow>
  );
};
